import { useState, useRef } from "react";
import Header from "../Common/Header";
import Footer from "../Common/Footer";

import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import axios from "axios";
import { ApiContext } from "../Context/Context";
import { use, useContext, useEffect } from "react";
import { getRecords, PostRecords } from "../Services/ApiCall";
import FeaturedProperty from "../Common/FeaturedProperties";
import ProjectsComp from "../Common/Projects";
import NearByProperties from "../Common/NearByProperties";
import { LoggedInUserID, LoggedInUserName } from "../Services/Urls";
import FilterParams from "../Classes/FilterParams";
import { useNavigate } from "react-router-dom";

import { TailSpin } from "react-loader-spinner";
import SelectDialog from "../Common/SelectDialog ";
import AmenitiesDialog from "../Common/AmenitiesDialog";

import { toast } from "react-toastify";

/* Styles */

function PostProperty() {
  const [step, setStep] = useState(1);
  const {
    logindata,
    setlogindata,
    userData,
    setuserData,
    CityData,

    coordinates,

    Locality,

    Area,
  } = useContext(ApiContext);

  const nextStep = () => step < 5 && setStep(step + 1);
  const prevStep = () => step > 1 && setStep(step - 1);

  const STEPS = [
    "Location",
    "Category",
    "Property Info",
    "Basic Details",
    "Map Location",
  ];

  const [BHKData, setBHKData] = useState([]);
  const [PropertyType, setPropertyType] = useState([]);
  const [Vertical, setVertical] = useState([]);
  const [AreaunitData, setAreaunitData] = useState([]);
  const [FurnishingData, setFurnishingData] = useState([]);
  const [ConstructionStatusData, setConstructionStatusData] = useState([]);
  const [ChooseProperty, setChooseProperty] = useState([]);
  const [locationHubData, setlocationHubData] = useState([
    { id: 1, name: "Mall", colorCode: "#000000" },
    { id: 2, name: "Commercial Project", colorCode: "#000000" },
    { id: 3, name: "Residential Project", colorCode: "#000000" },
    { id: 4, name: "Retail Complex/Building", colorCode: "#000000" },
    { id: 5, name: "Market/High Street", colorCode: "#000000" },
    { id: 6, name: "Others", colorCode: "#000000" },
  ]);
  const [selectedlocationHubData, setselectedlocationHubData] = useState({
    id: 2,
    name: "Commercial Project",
    colorCode: "#000000",
  });
  const [ownershipData, setownershipData] = useState([
    { id: 1, name: "Freehold", colorCode: "#000000" },
    { id: 2, name: "Leasehold", colorCode: "#000000" },
    { id: 3, name: "Power of Attorney", colorCode: "#000000" },
    { id: 4, name: "Cooperative Society", colorCode: "#000000" },
  ]);
  const [selectedownershipData, setselectedownershipData] = useState({
    id: 1,
    name: "Freehold",
    colorCode: "#000000",
  });
  const [preRented, setpreRented] = useState([
    { id: 1, name: "Yes", colorCode: "#000000" },
    { id: 2, name: "No", colorCode: "#000000" },
  ]);
  const [selectedpreRented, setselectedpreRented] = useState(null);
  const [PGName, setPGName] = useState("");
  const [PGisFor, setPGisFor] = useState([
    { id: 1, name: "Boys", colorCode: "#000000" },
    { id: 2, name: "Girls", colorCode: "#000000" },
  ]);
  const [selectedPGisFor, setselectedPGisFor] = useState(null);
  const [bestSuitedFor, setbestSuitedFor] = useState([
    { id: 1, name: "Students", colorCode: "#000000" },
    { id: 2, name: "Professionals", colorCode: "#000000" },
  ]);
  const [selectedbestSuitedFor, setselectedbestSuitedFor] = useState({
    id: 1,
    name: "Students",
    colorCode: "#000000",
  });
  const [MealsAvailable, setMealsAvailable] = useState([
    { id: 1, name: "Yes", colorCode: "#000000" },
    { id: 2, name: "No", colorCode: "#000000" },
  ]);
  const [selectedMealsAvailable, setselectedMealsAvailable] = useState(null);
  const [Noticeperiod, setNoticeperiod] = useState("");
  const [LockinPeriod, setLockinPeriod] = useState("");
  const [RoomTypeData, setRoomTypeData] = useState([]);
  const [selectedRoomTypeData, setselectedRoomTypeData] = useState([]);
  const [MealsOfferingData, setMealsOfferingData] = useState([]);
  const [selectedMealsOfferingData, setselectedMealsOfferingData] = useState(
    []
  );
  const [CommonAreaData, setCommonAreaData] = useState([]);
  const [selectedCommonAreaData, setselectedCommonAreaData] = useState([]);
  const [totalBeds, settotalBeds] = useState("");

  const [SocietyAmenities, setSocietyAmenities] = useState([]);
  const [selected_SocietyAmenities, setSelected_SocietyAmenities] = useState(
    []
  );
  const [PropertyAmenities, setPropertyAmenities] = useState([]);
  const [selected_PropertyAmenities, setSelected_PropertyAmenities] = useState(
    []
  );
  const [facingData, setFacingData] = useState([
    { id: 1, name: "North" },
    { id: 2, name: "South" },
    { id: 3, name: "East" },
    { id: 4, name: "West" },
    { id: 5, name: "North-East" },
    { id: 6, name: "North-West" },
    { id: 7, name: "South-East" },
    { id: 8, name: "South-West" },
  ]);

  const [selectedCity, setSelectedCity] = useState(null);
  const [selectedLocality, setSelectedLocality] = useState(null);
  const [selectedArea, setSelectedArea] = useState(null);
  const [selectedBHK, setSelectedBHK] = useState(null);
  const [selectedAreaUnit, setSelectedAreaUnit] = useState(null);
  const [selectedFurnishing, setselectedFurnishing] = useState(null);

  const [selectedPropertyType, setselectedPropertyType] = useState({
    _id: 1,
    PropertyType: "Residential",
    PropertyTypeID: 1,
    cDt: "04-Sep-2025 11:27:48",
  });
  const [Selected_ChooseProperty, setSelected_ChooseProperty] = useState(null);
  const [selectedVertical, setselectedVertical] = useState({
    _id: 5,
    Vertical: "Sale",
    VerticalID: 1,
    cDt: "09-Sep-2025 15:00:08",
  });
  const [selectedFacing, setselectedFacing] = useState(null);
  const [selected_constructionStatus, setselected_constructionStatus] =
    useState(null);
  const [buildupArea, setbuildupArea] = useState("");
  const [carpetArea, setcarpetArea] = useState("");
  const [price, setprice] = useState("");
  const [expectedReturn, setexpectedReturn] = useState("");
  const [securityDeposit, setsecurityDeposit] = useState("");
  const formatDate = (date) => {
    return new Intl.DateTimeFormat("en-GB", {
      day: "2-digit",
      month: "short",
      year: "2-digit",
    }).format(date);
  };

  const [availableDt, setAvailableDt] = useState(formatDate(new Date()));

  const [floorNo, setfloorNo] = useState("");
  const [Description, setDescription] = useState("");
  const [totalFloors, settotalFloors] = useState("");
  const [propertyAgeFields, setPropertyAgeFields] = useState([
    {
      id: 1,
      name: "Under Construction",
      colorCode: "#000000",
    },
    {
      id: 2,
      name: "1-5 Years",
      colorCode: "#000000",
    },
    {
      id: 3,
      name: "5-10 Years",
      colorCode: "#000000",
    },
    {
      id: 4,
      name: "10-15 Years",
      colorCode: "#000000",
    },
    {
      id: 5,
      name: "15+ Years",
      colorCode: "#000000",
    },
  ]);

  const [selectedPropertyAge, setSelectedPropertyAge] = useState(null);

  const [open, setOpen] = useState(false);

  const [openAmenitiesDialog, setOpenAmenitiesDialog] = useState(false);
  const [value, setValue] = useState("");
  const [dataFlag, setdataFlag] = useState(1);
  const [dataFlag_Amenities, setdataFlag_Amenities] = useState(1);

  const options = ["Faridabad", "Noida", "Jaipur", "Delhi", "Ghaziabad"];

  const handleSelectClick = (e) => {
    e.preventDefault(); // prevent default dropdown
    setOpen(true);
  };

  const handleOptionSelect = (option) => {
    setValue(option);
    setOpen(false);
  };

  useEffect(() => {
    getPropertyType();
    getVerticalType();
    getBHKType();
    getFurnishType();
    getAreaUnit();
    getConstructionStatus();
    getpropertyAmenities();
    getSocietyAmenities();
    getRoomData();
    getMealsData();
  }, []);

  useEffect(() => {
    getChoosePropertyType();
  }, [selectedVertical, selectedPropertyType]);

  const getChoosePropertyType = () => {
    getRecords(
      411,
      100,
      `{PropertyTypeID: { $in: [${selectedPropertyType?.PropertyTypeID}] },VerticalID: { $in: [${selectedVertical?.VerticalID}] }}`,
      1,
      "",
      (data) => {
        if (data != null) {
          if (data?.hasErrors === false && data?.response?.records != null) {
            setChooseProperty(data?.response?.records || []);
          } else {
            setChooseProperty([]);
            console.log("Error in fetching featured properties", data);
          }
        }
      }
    );
  };

  const getPropertyType = () => {
    getRecords(391, 100, `{}`, 1, "", (data) => {
      if (data != null) {
        if (data?.hasErrors === false && data?.response?.records != null) {
          setPropertyType(data?.response?.records || []);
        } else {
          console.log("Error in fetching featured properties", data);
        }
      }
    });
  };

  const getVerticalType = () => {
    getRecords(392, 100, `{}`, 1, "", (data) => {
      if (data != null) {
        if (data?.hasErrors === false && data?.response?.records != null) {
          setVertical(data?.response?.records || []);
        } else {
          console.log("Error in fetching featured properties", data);
        }
      }
    });
  };

  const getBHKType = () => {
    getRecords(394, 100, `{}`, 1, "", (data) => {
      if (data != null) {
        if (data?.hasErrors === false && data?.response?.records != null) {
          setBHKData(data?.response?.records || []);
        } else {
          setBHKData([]);
          console.log("Error in fetching featured properties", data);
        }
      }
    });
  };

  const getFurnishType = () => {
    getRecords(395, 100, `{}`, 1, "", (data) => {
      if (data != null) {
        if (data?.hasErrors === false && data?.response?.records != null) {
          setFurnishingData(data?.response?.records || []);
        } else {
          setFurnishingData([]);
          console.log("Error in fetching featured properties", data);
        }
      }
    });
  };

  const getAreaUnit = () => {
    getRecords(407, 100, `{}`, 1, "", (data) => {
      if (data != null) {
        if (data?.hasErrors === false && data?.response?.records != null) {
          setAreaunitData(data?.response?.records || []);
        } else {
          setAreaunitData([]);
          console.log("Error in fetching featured properties", data);
        }
      }
    });
  };

  const getpropertyAmenities = () => {
    getRecords(397, 100, `{}`, 1, "", (data) => {
      if (data != null) {
        if (data?.hasErrors === false && data?.response?.records != null) {
          setPropertyAmenities(data?.response?.records || []);
        } else {
          setPropertyAmenities([]);
          console.log("Error in fetching featured properties", data);
        }
      }
    });
  };

  const getSocietyAmenities = () => {
    getRecords(396, 100, `{}`, 1, "", (data) => {
      if (data != null) {
        if (data?.hasErrors === false && data?.response?.records != null) {
          setSocietyAmenities(data?.response?.records || []);
        } else {
          setSocietyAmenities([]);
          console.log("Error in fetching featured properties", data);
        }
      }
    });
  };

  const getConstructionStatus = () => {
    getRecords(406, 100, `{}`, 1, "", (data) => {
      if (data != null) {
        if (data?.hasErrors === false && data?.response?.records != null) {
          setConstructionStatusData(data?.response?.records || []);
        } else {
          setConstructionStatusData([]);
          console.log("Error in fetching featured properties", data);
        }
      }
    });
  };
  const getRoomData = () => {
    getRecords(421, 100, `{}`, 1, "", (data) => {
      if (data != null) {
        if (data?.hasErrors === false && data?.response?.records != null) {
          setRoomTypeData(data?.response?.records || []);
        } else {
          setRoomTypeData([]);
          console.log("Error in fetching featured properties", data);
        }
      }
    });
  };

  const getMealsData = () => {
    getRecords(422, 100, `{}`, 1, "", (data) => {
      if (data != null) {
        if (data?.hasErrors === false && data?.response?.records != null) {
          setMealsOfferingData(data?.response?.records || []);
        } else {
          setMealsOfferingData([]);
          console.log("Error in fetching featured properties", data);
        }
      }
    });
  };

  const PostPropertyData = () => {
    const postData = [
      {
        City: selectedCity?.City,
        CityAlias: selectedCity?.CityAlias,
        PropertyType: selectedPropertyType?.PropertyType,
        PropertyTypeID: selectedPropertyType?.PropertyTypeID,
        Vertical: selectedVertical?.Vertical,
        VerticalID: selectedVertical?.VerticalID,
        CityID: selectedCity?.CityID,
        ChooseProperty: Selected_ChooseProperty?.ChooseProperty,
        ChoosePropertyID: Selected_ChooseProperty?.ChoosePropertyID,
        Society: selectedArea?.SubArea,
        SocietyID: selectedArea?.SubAreaID,
        Locality: selectedLocality?.Locality,
        LocalityID: selectedLocality?.LocalityID,
        State: selectedCity?.State,
        Country: selectedCity?.Country,

        Title: `${selectedBHK?.BHKUnit} ${Selected_ChooseProperty?.ChooseProperty} in ${selectedLocality?.Locality}`,
        Description: Description,

        BHK: selectedBHK?.BHKUnit,
        BHKID: selectedBHK?.BHKID,
        BuiltUpArea: buildupArea,
        UOMName: selectedAreaUnit?.UOMName,
        UOMID: selectedAreaUnit?.UOMID,

        FurnishType: selectedFurnishing?.FurnishType,
        FurnishID: selectedFurnishing?.FurnishID,

        UnitFurnishingtitle: selected_PropertyAmenities,

        PropertyAmenities: selected_SocietyAmenities,

        Price: price,

        ConstructionStatus: selected_constructionStatus?.ConstructionStatus,
        ConstructionStatusID: selected_constructionStatus?.ConstructionStatusID,
        LocationHub: selectedlocationHubData?.name,
        LocationHubID: selectedlocationHubData?.id,
        Ownership: selectedownershipData?.name,
        OwnershipID:selectedownershipData?.id,
        Isitpreleasedprerented: selectedpreRented?.name,
        IsitpreleasedprerentedID: selectedpreRented?.id,
        PGName : PGName,
        TotalBeds :  totalBeds,
        PGisfor : selectedPGisFor?.name,
        BestSuitedfor : selectedbestSuitedFor?.name ,
        MealsAvailable : selectedMealsAvailable?.name ,
        PgisforID :selectedPGisFor?.id ,
        BestSuitedforID : selectedbestSuitedFor?.id,
        MealsAvailableID : selectedMealsAvailable?.id,
        CommonArea :selectedCommonAreaData ,
        MealsOfferings : selectedMealsOfferingData ,
        NoticePeriod : Noticeperiod ,
        LockInPeriod :LockinPeriod ,
        CommonAreas : selectedCommonAreaData ,
        R1_SecurityDeposit : securityDeposit,
        R1_RoomType : selectedRoomTypeData ,

        MonthlyRent : price ,
SecurityDeposit :securityDeposit ,
AvailableFrom : availableDt, 
              



        CarpetArea: "",
        ExpectedROI: expectedReturn,
        PropertyAge: selectedPropertyAge?.name,
        AgeofProperty: selectedPropertyAge?.name,

        SellerName: userData?.User,
        SellerID: userData?.UserID,
        SellerMobile: userData?.Mobile,
        Profile: userData?.Profile,
        ProfileID: userData?.ProfileID,

        Status: "In Review",
        StatusID: "1",

        Images: "",
        BathroomImage: "",
        KitchenImage: "",

        TotalFloor: totalFloors,
        FloorNo: floorNo,
        Facing: selectedFacing?.name,

        Coordinates: [coordinates?.latitude, coordinates?.longitude],
      },
    ];

    const tabID =
      selectedPropertyType?.PropertyTypeID === 1 &&
      selectedVertical?.VerticalID === 1
        ? 384
        : selectedPropertyType?.PropertyTypeID === 1 &&
          selectedVertical?.VerticalID === 2
        ? 385
        : selectedPropertyType?.PropertyTypeID === 1 &&
          selectedVertical?.VerticalID === 3
        ? 386
        : selectedPropertyType?.PropertyTypeID === 2 &&
          selectedVertical?.VerticalID === 1
        ? 387
        : 388;

    PostRecords(tabID, 1, postData, (data) => {
      if (data != null && data?.response?.hasErrors === false) {
        toast.success(`Property Posted Successfully`);
      } else {
        toast.error(`${data?.errors}`);
      }
    });

    console.log("Post Data:", postData);
  };

  return (
    <>
      <Header />
      <section className="pt-140 pb-75 bg-seashell postproperty">
        <div className="container">
          <div className="row">
            <div className="col-md-3 col-sm-3 d-desk">
              <div className="card">
                <h4 className="title tle">Post your property</h4>
                <div className="stepper">
                  {STEPS.map((label, index) => {
                    const stepNumber = index + 1;
                    return (
                      <div key={label} className="step-item">
                        <div
                          className={`step-dot ${
                            step >= stepNumber ? "active" : ""
                          }`}
                        >
                          {stepNumber}
                        </div>
                        <span
                          className={`step-label ${
                            step === stepNumber ? "current" : ""
                          }`}
                        >
                          {label}
                        </span>
                      </div>
                    );
                  })}
                </div>

                <p className="step-text">Need help?</p>
                <small>Now you can directly post property via</small>
                <span className="Whatsapp">
                  <i className="ri-whatsapp-line" /> Whatsapp
                </span>
              </div>
            </div>
            <div className="col-md-9 col-sm-9 wd100">
              <div className="stepper d-mobilee">
                {STEPS.map((label, index) => {
                  const stepNumber = index + 1;
                  return (
                    <div key={label} className="step-item">
                      <div
                        className={`step-dot ${
                          step >= stepNumber ? "active" : ""
                        }`}
                      >
                        {stepNumber}
                      </div>
                      <span
                        className={`step-label ${
                          step === stepNumber ? "current" : ""
                        }`}
                      >
                        {label}
                      </span>
                    </div>
                  );
                })}
              </div>
              <div className="content card">
                {step === 1 && (
                  <>
                    <h4>Location Details</h4>

                    {/* <div class="form-group">
                      <select
                        value={value}
                        onMouseDown={handleSelectClick}
                        style={{ padding: "10px" }}
                      >
                        <option value="">
                          {value ? value : "Select City"}
                        </option>
                      </select>
                    </div> */}

                    <div class="form-group">
                      <label className="label">
                        City<span className="red">*</span>
                      </label>
                      <select
                        value={selectedCity?.City}
                        onMouseDown={(e) => {
                          e.preventDefault();

                          setdataFlag(1);
                          setOpen(true);
                        }}
                        style={{ padding: "10px" }}
                      >
                        <option value="">
                          {selectedCity?.City
                            ? selectedCity?.City
                            : "Select City"}
                        </option>
                      </select>
                    </div>

                    <div class="form-group">
                      <label className="label">
                        Locality<span className="red">*</span>
                      </label>
                      <select
                        value={selectedLocality?.Locality}
                        //disabled={selectedCity == null}
                        onMouseDown={(e) => {
                          if (selectedCity != null) {
                            e.preventDefault();
                            setdataFlag(2);
                            setOpen(true);
                          } else {
                            //  <Toast title="Please select city first!" />
                            //  alert("Please select city first!");
                            toast.error("Please select city first!");
                          }
                        }}
                        style={{ padding: "10px" }}
                      >
                        <option value="">
                          {selectedLocality?.Locality
                            ? selectedLocality?.Locality
                            : "Select Locality"}
                        </option>
                      </select>
                    </div>

                    <div class="form-group">
                      <label className="label">
                        Street/Building/Area<span className="red">*</span>
                      </label>
                      <select
                        value={selectedArea?.SubArea}
                        //  disabled={selectedLocality == null}
                        onMouseDown={(e) => {
                          if (selectedLocality != null) {
                            e.preventDefault();

                            setdataFlag(3);
                            setOpen(true);
                          } else {
                            toast.error("Please select locality first!");
                          }
                        }}
                        style={{ padding: "10px" }}
                      >
                        <option value="">
                          {selectedArea?.SubArea
                            ? selectedArea?.SubArea
                            : "Select Area"}
                        </option>
                      </select>
                    </div>

                    {/* Dialog */}

                    {open && (
                      <SelectDialog
                        open={open}
                        title="Select City"
                        placeholder="Search City"
                        selectedCity={selectedCity}
                        selectedLocality={selectedLocality}
                        selectedArea={selectedArea}
                        onClose={() => setOpen(false)}
                        dataFlag={dataFlag}
                        onSelect={(option) => {
                          if (dataFlag === 1) setSelectedCity(option);
                          if (dataFlag === 2) setSelectedLocality(option);
                          if (dataFlag === 3) setSelectedArea(option);
                          setOpen(false);
                        }}
                      />
                    )}
                  </>
                )}
                {step === 2 && (
                  <Step2
                    PropertyType={PropertyType}
                    selectedPropertyType={selectedPropertyType}
                    setselectedPropertyType={setselectedPropertyType}
                    Vertical={Vertical}
                    selectedVertical={selectedVertical}
                    setselectedVertical={setselectedVertical}
                    ChooseProperty={ChooseProperty}
                    Selected_ChooseProperty={Selected_ChooseProperty}
                    setSelected_ChooseProperty={setSelected_ChooseProperty}
                  />
                )}
                {step === 3 && (
                  <Step3
                    BHKData={BHKData}
                    selectedBHK={selectedBHK}
                    setSelectedBHK={setSelectedBHK}
                    AreaunitData={AreaunitData}
                    selectedAreaUnit={selectedAreaUnit}
                    setSelectedAreaUnit={setSelectedAreaUnit}
                    buildupArea={buildupArea}
                    setbuildupArea={setbuildupArea}
                    price={price}
                    setprice={setprice}
                    FurnishingData={FurnishingData}
                    selectedFurnishing={selectedFurnishing}
                    setselectedFurnishing={setselectedFurnishing}
                    SocietyAmenities={SocietyAmenities}
                    selected_SocietyAmenities={selected_SocietyAmenities}
                    setSelected_SocietyAmenities={setSelected_SocietyAmenities}
                    PropertyAmenities={PropertyAmenities}
                    selected_PropertyAmenities={selected_PropertyAmenities}
                    setSelected_PropertyAmenities={
                      setSelected_PropertyAmenities
                    }
                    floorNo={floorNo}
                    setfloorNo={setfloorNo}
                    totalFloors={totalFloors}
                    settotalFloors={settotalFloors}
                    ConstructionStatusData={ConstructionStatusData}
                    selected_constructionStatus={selected_constructionStatus}
                    setselected_constructionStatus={
                      setselected_constructionStatus
                    }
                    facingData={facingData}
                    selectedFacing={selectedFacing}
                    setselectedFacing={setselectedFacing}
                    propertyAgeFields={propertyAgeFields}
                    selectedPropertyAge={selectedPropertyAge}
                    setSelectedPropertyAge={setSelectedPropertyAge}
                    openAmenitiesDialog={openAmenitiesDialog}
                    setOpenAmenitiesDialog={setOpenAmenitiesDialog}
                    dataFlag_Amenities={dataFlag_Amenities}
                    setdataFlag_Amenities={setdataFlag_Amenities}
                    selectedPropertyType={selectedPropertyType}
                    selectedVertical={selectedVertical}
                    Selected_ChooseProperty={Selected_ChooseProperty}
                    securityDeposit={securityDeposit}
                    setsecurityDeposit={setsecurityDeposit}
                    availableDt={availableDt}
                    setAvailableDt={setAvailableDt}
                    locationHubData={locationHubData}
                    setlocationHubData={setlocationHubData}
                    selectedlocationHubData={selectedlocationHubData}
                    setselectedlocationHubData={setselectedlocationHubData}
                    ownershipData={ownershipData}
                    setownershipData={setownershipData}
                    selectedownershipData={selectedownershipData}
                    setselectedownershipData={setselectedownershipData}
                    preRented={preRented}
                    selectedpreRented={selectedpreRented}
                    setselectedpreRented={setselectedpreRented}
                    PGName={PGName}
                    setPGName={setPGName}
                    PGisFor={PGisFor}
                    selectedPGisFor={selectedPGisFor}
                    setselectedPGisFor={setselectedPGisFor}
                    bestSuitedFor={bestSuitedFor}
                    selectedbestSuitedFor={selectedbestSuitedFor}
                    setselectedbestSuitedFor={setselectedbestSuitedFor}
                    MealsAvailable={MealsAvailable}
                    selectedMealsAvailable={selectedMealsAvailable}
                    setselectedMealsAvailable={setselectedMealsAvailable}
                    Noticeperiod={Noticeperiod}
                    setNoticeperiod={setNoticeperiod}
                    LockinPeriod={LockinPeriod}
                    setLockinPeriod={setLockinPeriod}
                    RoomTypeData={RoomTypeData}
                    selectedRoomTypeData={selectedRoomTypeData}
                    setselectedRoomTypeData={setselectedRoomTypeData}
                    MealsOfferingData={MealsOfferingData}
                    selectedMealsOfferingData={selectedMealsOfferingData}
                    setselectedMealsOfferingData={setselectedMealsOfferingData}
                    CommonAreaData={CommonAreaData}
                    selectedCommonAreaData={selectedCommonAreaData}
                    setselectedCommonAreaData={setselectedCommonAreaData}
                    totalBeds={totalBeds}
                    settotalBeds={settotalBeds}
                    expectedReturn={expectedReturn}
                    setexpectedReturn={setexpectedReturn}
                    open={open}
                    setOpen={setOpen}
                    dataFlag={dataFlag}
                    setdataFlag={setdataFlag}
                  />
                )}
                {step === 4 && (
                  <Step4
                    Description={Description}
                    setDescription={setDescription}
                  />
                )}
                {step === 5 && <Step5 coordinates={coordinates} />}
              </div>

              <div className="footers">
                <button
                  className="btn secondary"
                  disabled={step === 1}
                  onClick={prevStep}
                >
                  Previous
                </button>

                {step < 5 ? (
                  <button className="btn primary" onClick={nextStep}>
                    {step === 1 ? "Next Step" : "Next"}
                  </button>
                ) : (
                  <button onClick={PostPropertyData} className="btn primary">
                    Submit
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

function Step2({
  PropertyType,
  selectedPropertyType,
  setselectedPropertyType,
  Vertical,
  selectedVertical,
  setselectedVertical,
  ChooseProperty,
  Selected_ChooseProperty,
  setSelected_ChooseProperty,
}) {
  return (
    <>
      <h4>Category & Property Type</h4>

      <label className="label">
        Category<span className="red">*</span>
      </label>
      <ButtonGroup
        options={PropertyType}
        selectedoption={selectedPropertyType}
        setselectedoption={setselectedPropertyType}
        flag={1}
      />

      <label className="label">
        Looking To<span className="red">*</span>
      </label>
      <ButtonGroup
        options={Vertical}
        selectedoption={selectedVertical}
        setselectedoption={setselectedVertical}
        flag={2}
      />

      <label className="label">
        Property Type<span className="red">*</span>
      </label>
      <ButtonGroup
        options={ChooseProperty}
        selectedoption={Selected_ChooseProperty}
        setselectedoption={setSelected_ChooseProperty}
        flag={3}
      />
    </>
  );
}

function Step3({
  BHKData,
  selectedBHK,
  setSelectedBHK,
  AreaunitData,
  selectedAreaUnit,
  setSelectedAreaUnit,
  buildupArea,
  setbuildupArea,
  price,
  setprice,
  FurnishingData,
  selectedFurnishing,
  setselectedFurnishing,
  SocietyAmenities,
  selected_SocietyAmenities,
  setSelected_SocietyAmenities,
  PropertyAmenities,
  selected_PropertyAmenities,
  setSelected_PropertyAmenities,
  floorNo,
  setfloorNo,
  totalFloors,
  settotalFloors,
  ConstructionStatusData,
  selected_constructionStatus,
  setselected_constructionStatus,
  facingData,
  selectedFacing,
  setselectedFacing,
  propertyAgeFields,
  selectedPropertyAge,
  setSelectedPropertyAge,
  openAmenitiesDialog,
  setOpenAmenitiesDialog,
  dataFlag_Amenities,
  setdataFlag_Amenities,
  selectedPropertyType,
  selectedVertical,
  Selected_ChooseProperty,
  securityDeposit,
  setsecurityDeposit,
  availableDt,
  setAvailableDt,
  locationHubData,
  setlocationHubData,
  selectedlocationHubData,
  setselectedlocationHubData,
  ownershipData,
  setownershipData,
  selectedownershipData,
  setselectedownershipData,
  preRented,
  selectedpreRented,
  setselectedpreRented,
  PGName,
  setPGName,
  PGisFor,
  selectedPGisFor,
  setselectedPGisFor,
  bestSuitedFor,
  selectedbestSuitedFor,
  setselectedbestSuitedFor,
  MealsAvailable,
  selectedMealsAvailable,
  setselectedMealsAvailable,
  Noticeperiod,
  setNoticeperiod,
  LockinPeriod,
  setLockinPeriod,
  RoomTypeData,
  selectedRoomTypeData,
  setselectedRoomTypeData,
  MealsOfferingData,
  selectedMealsOfferingData,
  setselectedMealsOfferingData,
  CommonAreaData,
  selectedCommonAreaData,
  setselectedCommonAreaData,
  totalBeds,
  settotalBeds,
  expectedReturn,
  setexpectedReturn,
  open,
  setOpen,
  dataFlag,
  setdataFlag,
}) {
  const formatDate = (date) =>
    new Intl.DateTimeFormat("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    }).format(date);
  const dateRef = useRef(null);

  const [AvailableDtRaw, setAvailableDtRaw] = useState("");

  return (
    <>
      <h4>Property Information</h4>

      {Selected_ChooseProperty?.BHK === "Y" && (
        <div className="form-group">
          <label className="label">
            BHK Type<span className="red">*</span>
          </label>

          <ButtonGroup
            options={BHKData}
            selectedoption={selectedBHK}
            setselectedoption={setSelectedBHK}
            flag={4}
          />
        </div>
      )}

      {selectedVertical?.VerticalID !== 3 && (
        <>
          <div className="form-group">
            <label className="label">
              Area Unit<span className="red">*</span>
            </label>
            <ButtonGroup
              options={AreaunitData}
              selectedoption={selectedAreaUnit}
              setselectedoption={setSelectedAreaUnit}
              flag={5}
            />
          </div>

          <div className="form-group">
            <label className="label">
              Built-up Area {`(${selectedAreaUnit?.UOMName})`}
              <span className="red">*</span>
            </label>
            <input
              value={buildupArea}
              onChange={(e) => setbuildupArea(e.target.value)}
              className="input"
              placeholder="eg 1250"
            />
          </div>

          <div className="form-group">
            <label className="label">
              {selectedVertical?.VerticalID == 1 ? "Price" : "Monthly Rent"}{" "}
              (Rs)
              <span className="red">*</span>
            </label>
            <input
              value={price}
              onChange={(e) => setprice(e.target.value)}
              className="input"
              placeholder="eg10"
            />
          </div>
        </>
      )}

      {selectedPropertyType?.PropertyTypeID === 1 &&
        selectedVertical?.VerticalID === 3 && (
          <>
            <div className="form-group">
              <label className="label">
                PG Name<span className="red">*</span>
              </label>
              <input
                value={PGName}
                onChange={(e) => setPGName(e.target.value)}
                className="input"
                placeholder="eg Shri Ram PG"
              />
            </div>

            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label className="label">
                    Notice Period (days)<span className="red">*</span>
                  </label>
                  <input
                    value={Noticeperiod}
                    onChange={(e) => setNoticeperiod(e.target.value)}
                    className="input"
                    placeholder="eg 5"
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label className="label">
                    Lock In Period (days)<span className="red">*</span>
                  </label>
                  <input
                    value={LockinPeriod}
                    onChange={(e) => setLockinPeriod(e.target.value)}
                    className="input"
                    placeholder="eg 10"
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label className="label">
                    Security Deposit (Rs)<span className="red">*</span>
                  </label>
                  <input
                    value={securityDeposit}
                    onChange={(e) => setsecurityDeposit(e.target.value)}
                    className="input"
                    placeholder="eg 5000"
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label className="label">
                    Total Beds<span className="red">*</span>
                  </label>
                  <input
                    value={totalBeds}
                    onChange={(e) => settotalBeds(e.target.value)}
                    className="input"
                    placeholder="eg 3"
                  />
                </div>
              </div>
            </div>

            <div className="form-group">
              <label className="label">
                PG is for<span className="red">*</span>
              </label>
              <ButtonGroup
                options={PGisFor}
                selectedoption={selectedPGisFor}
                setselectedoption={setselectedPGisFor}
                flag={12}
              />
            </div>

            <div className="form-group">
              <label className="label">
                Best suited for<span className="red">*</span>
              </label>
              <ButtonGroup
                options={bestSuitedFor}
                selectedoption={selectedbestSuitedFor}
                setselectedoption={setselectedbestSuitedFor}
                flag={13}
              />
            </div>

            <div className="form-group">
              <label className="label">
                Meals Available<span className="red">*</span>
              </label>
              <ButtonGroup
                options={MealsAvailable}
                selectedoption={selectedMealsAvailable}
                setselectedoption={setselectedMealsAvailable}
                flag={14}
              />
            </div>

            <div class="form-group">
              <label className="label">
                Meals<span className="red">*</span>
              </label>
              <select
                // value={selectedCity?.City}
                onMouseDown={(e) => {
                  e.preventDefault();

                  setdataFlag(4);
                  setOpen(true);
                }}
                style={{ padding: "10px" }}
              >
                <option value="">
                  {selectedMealsOfferingData?.length > 0
                    ? selectedMealsOfferingData
                        ?.map((item) => item.MealOffering)
                        .join(", ")
                    : "Select Meals Offering"}
                </option>
              </select>
            </div>

             <div class="form-group">
              <label className="label">
                Common Areas<span className="red">*</span>
              </label>
              <select
                // value={selectedCity?.City}
                onMouseDown={(e) => {
                  e.preventDefault();

                  setdataFlag(5);
                  setOpen(true);
                }}
                style={{ padding: "10px" }}
              >
                <option value="">
                  {selectedCommonAreaData?.length > 0
                    ? selectedCommonAreaData
                        ?.map((item) => item.CommonArea)
                        .join(", ")
                    : "Select Common Areas"}
                </option>
              </select>
            </div>

              <div class="form-group">
              <label className="label">
                Room Types<span className="red">*</span>
              </label>
              <select
                // value={selectedCity?.City}
                onMouseDown={(e) => {
                  e.preventDefault();

                  setdataFlag(6);
                  setOpen(true);
                }}
                style={{ padding: "10px" }}
              >
                <option value="">
                  {selectedRoomTypeData?.length > 0
                    ? selectedRoomTypeData
                        ?.map((item) => item.RoomType)
                        .join(", ")
                    : "Select Room Types"}
                </option>
              </select>
            </div>
          </>
        )}

      {selectedPropertyType?.PropertyTypeID === 2 &&
        (selectedVertical?.VerticalID === 1 ||
          selectedVertical?.VerticalID === 2) && (
          <>
            <div className="form-group">
              <label className="label">
                {"Expected Return"} (%)
                <span className="red">*</span>
              </label>
              <input
                value={expectedReturn}
                onChange={(e) => setexpectedReturn(e.target.value)}
                className="input"
                placeholder="eg10"
              />
            </div>

            <div className="form-group">
              <label className="label">
                Location Hub<span className="red">*</span>
              </label>
              <ButtonGroup
                options={locationHubData}
                selectedoption={selectedlocationHubData}
                setselectedoption={setselectedlocationHubData}
                flag={9}
              />
            </div>

            <div className="form-group">
              <label className="label">
                Ownership<span className="red">*</span>
              </label>
              <ButtonGroup
                options={ownershipData}
                selectedoption={selectedownershipData}
                setselectedoption={setselectedownershipData}
                flag={10}
              />
            </div>

            <div className="form-group">
              <label className="label">
                Is it pre-rented ?<span className="red">*</span>
              </label>
              <ButtonGroup
                options={preRented}
                selectedoption={selectedpreRented}
                setselectedoption={setselectedpreRented}
                flag={11}
              />
            </div>
          </>
        )}

      {(selectedPropertyType?.PropertyTypeID === 1 ||
        selectedPropertyType?.PropertyTypeID === 2) &&
        selectedVertical?.VerticalID === 2 && (
          <>
            <div className="form-group">
              <label className="label">
                Security Deposit (Rs)<span className="red">*</span>
              </label>
              <input
                value={securityDeposit}
                onChange={(e) => setsecurityDeposit(e.target.value)}
                className="input"
                placeholder="eg1000"
              />
            </div>

            <div className="form-group">
              <label className="label">
                Available From<span className="red">*</span>
              </label>

              <input
                type="text"
                className="input"
                readOnly
                value={`📅 ${availableDt}`}
                onClick={() => dateRef.current.showPicker()}
              />

              <input
                type="date"
                ref={dateRef}
                style={{
                  position: "absolute",
                  width: 0,
                  height: 0,
                  opacity: 0,
                  border: "none",
                  padding: 0,
                  margin: 0,
                }}
                onChange={(e) =>
                  setAvailableDt(formatDate(new Date(e.target.value)))
                }
              />
            </div>

            {/* <div
              className="date-row"
              onClick={() => dateRef.current.showPicker()}
            >
              <span className="icon">📅</span>

              <span className="date-text">{availableDt}</span>

              <span className="spacer" />

              <span className="icon">▾</span>

              <input
                type="date"
                ref={dateRef}
                min={new Date().toISOString().split("T")[0]}
                onChange={(e) =>
                  setAvailableDt(formatDate(new Date(e.target.value)))
                }
                style={{
                  position: "absolute",
                  width: 0,
                  height: 0,
                  opacity: 0,
                  border: "none",
                  padding: 0,
                  margin: 0,
                }}
              />
            </div> */}
          </>
        )}

      {Selected_ChooseProperty?.BHK === "Y" && (
        <>
          <div className="form-group">
            <label className="label">
              Furnishing<span className="red">*</span>
            </label>
            <ButtonGroup
              options={FurnishingData}
              selectedoption={selectedFurnishing}
              setselectedoption={setselectedFurnishing}
              flag={6}
            />
          </div>

          <div class="form-group">
            <label className="label">
              Society Amenities<span className="red">*</span>
            </label>
            <select
              onMouseDown={(e) => {
                e.preventDefault();
                setdataFlag_Amenities(1);

                setOpenAmenitiesDialog(true);
              }}
              name="category"
              id="category"
            >
              <option value="">
                {selected_SocietyAmenities?.length > 0
                  ? selected_SocietyAmenities
                      ?.map((item) => item.PropertyAmenities)
                      .join(", ")
                  : "Select Society Amenities"}
              </option>
            </select>
          </div>

          <div class="form-group">
            <label className="label">
              Property Furnishing<span className="red">*</span>
            </label>
            <select
              onMouseDown={(e) => {
                e.preventDefault();
                setdataFlag_Amenities(2);

                setOpenAmenitiesDialog(true);
              }}
              name="category"
              id="category"
            >
              <option value="">
                {selected_PropertyAmenities?.length > 0
                  ? selected_PropertyAmenities
                      ?.map((item) => item.UnitFurnishing)
                      .join(", ")
                  : "Select Property Furnishing"}
              </option>
            </select>
          </div>

          <div className="row">
            <div className="col-md-6">
              <div className="form-group">
                <label className="label">
                  Floor No.<span className="red">*</span>
                </label>
                <input
                  value={floorNo}
                  onChange={(e) => setfloorNo(e.target.value)}
                  className="input"
                  placeholder="eg 1"
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label className="label">
                  Total Floors<span className="red">*</span>
                </label>
                <input
                  value={totalFloors}
                  onChange={(e) => settotalFloors(e.target.value)}
                  className="input"
                  placeholder="eg 10"
                />
              </div>
            </div>
          </div>

          <div class="form-group">
            <label className="label">
              Property Age<span className="red">*</span>
            </label>
            <select name="category" id="category">
              {propertyAgeFields?.map((option) => (
                <option
                  onClick={setSelectedPropertyAge(option)}
                  key={option.id}
                  value={option.name}
                >
                  {option.name}
                </option>
              ))}
            </select>
          </div>
        </>
      )}

      {selectedPropertyType?.PropertyTypeID === 1 &&
        (selectedVertical?.VerticalID === 1 ||
          selectedVertical?.VerticalID === 2) && (
          <div className="form-group">
            <label className="label">
              Facing<span className="red">*</span>
            </label>
            <ButtonGroup
              options={facingData}
              selectedoption={selectedFacing}
              setselectedoption={setselectedFacing}
              flag={7}
            />
          </div>
        )}

      {Selected_ChooseProperty?.BHK === "Y" && (
        <div className="form-group">
          <label className="label">
            Construction Satus<span className="red">*</span>
          </label>
          <ButtonGroup
            options={ConstructionStatusData}
            selectedoption={selected_constructionStatus}
            setselectedoption={setselected_constructionStatus}
            flag={8}
          />
        </div>
      )}

      {openAmenitiesDialog && (
        <AmenitiesDialog
          AmenitiesData={
            dataFlag_Amenities === 1 ? SocietyAmenities : PropertyAmenities
          }
          selectedData={
            dataFlag_Amenities === 1
              ? selected_SocietyAmenities
              : selected_PropertyAmenities
          }
          flag={dataFlag_Amenities}
          onClose={() => setOpenAmenitiesDialog(false)}
          onSelect={(data) => {
            if (dataFlag_Amenities === 1) {
              setSelected_SocietyAmenities((prev) => {
                const exists = prev.some(
                  (item) =>
                    item.PropertyAmenitiesID === data.PropertyAmenitiesID
                );

                if (exists) {
                  // remove
                  return prev.filter(
                    (item) =>
                      item.PropertyAmenitiesID !== data.PropertyAmenitiesID
                  );
                }

                // add
                return [...prev, data];
              });
            } else if (dataFlag_Amenities === 2) {
              setSelected_PropertyAmenities((prev) => {
                const exists = prev.some(
                  (item) => item.UnitFurnishingID === data.UnitFurnishingID
                );

                if (exists) {
                  // remove
                  return prev.filter(
                    (item) => item.UnitFurnishingID !== data.UnitFurnishingID
                  );
                }

                // add
                return [...prev, data];
              });
            }
            // setSelected_PropertyAmenities((prev) => [...prev, data]);
          }}

          // open={open}
          // title="Select City"
          // placeholder="Search City"
          // selectedCity={selectedCity}
          // selectedLocality={selectedLocality}
          // selectedArea={selectedArea}
          // onClose={() => setOpen(false)}
          // dataFlag={dataFlag}
          // onSelect={(option) => {
          //   if (dataFlag === 1) setSelectedCity(option);
          //   if (dataFlag === 2) setSelectedLocality(option);
          //   if (dataFlag === 3) setSelectedArea(option);
          //   setOpen(false);
          // }}
        />
      )}

      {open && (
        <SelectDialog
          open={open}
          title="Select City"
          placeholder="Search"
          selectedCity={{}}
          selectedLocality={{}}
          selectedArea={ dataFlag === 4 ? selectedMealsOfferingData : dataFlag === 5 ? selectedCommonAreaData : dataFlag === 6 ? selectedRoomTypeData : selectedMealsOfferingData}
          onClose={() => setOpen(false)}
          dataFlag={dataFlag}
          onSelect={(data) => {
            if (dataFlag === 4)
              setselectedMealsOfferingData((prev) => {
                const exists = prev.some((item) => item.ID === data.ID);

                if (exists) {
                  // remove
                  return prev.filter((item) => item.ID !== data.ID);
                }

                // add
                return [...prev, data];
              });

            if (dataFlag === 5)
              setselectedCommonAreaData((prev) => {
                const exists = prev.some((item) => item.ID === data.ID);

                if (exists) {
                  // remove
                  return prev.filter((item) => item.ID !== data.ID);
                }

                // add
                return [...prev, data];
              });
            if (dataFlag === 6)
              setselectedRoomTypeData((prev) => {
                const exists = prev.some((item) => item.ID === data.ID);

                if (exists) {
                  // remove
                  return prev.filter((item) => item.ID !== data.ID);
                }

                // add
                return [...prev, data];
              });
            // setOpen(false);
          }}
        />
      )}

      {/* <div class="form-group">
        <label className="label">
          Location Hub<span className="red">*</span>
        </label>
        <ButtonGroup
          options={[
            "North",
            "South",
            "East",
            "West",
            "North-East",
            "North-West",
            "South-East",
            "South-West",
          ]}
        />
      </div> */}
    </>
  );
}

function Step4({ Description, setDescription }) {
  return (
    <>
      <h4>Basic Details</h4>
      <div class="form-group">
        <label className="label">
          Description<span className="red">*</span>
        </label>
        <textarea
          className="textarea"
          placeholder="Describe your property features, facilities, and amenities etc."
          value={Description}
          onChange={(e) => setDescription(e.target.value)}
        />
      </div>
    </>
  );
}

function Step5({ coordinates }) {
  return (
    <>
      <h4>Location Information</h4>

      <div class="form-group">
        <input className="input" placeholder="Search location" />
      </div>
      <div className="map-placeholder">
        <iframe
          src={`https://www.google.com/maps?q=${coordinates?.latitude},${coordinates?.longitude}&hl=en&z=15&output=embed`}
          width="100%"
          height="100%"
          allowfullscreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </>
  );
}

function ButtonGroup({ options, selectedoption, setselectedoption, flag }) {
  // const [active, setActive] = useState(options[0]);
  // console.log("options", options);

  const getOptionLabel = (option) => {
    if (flag === 1) {
      return option?.PropertyType;
    } else if (flag === 2) {
      return option.Vertical;
    } else if (flag === 3) {
      return option?.ChooseProperty;
    } else if (flag === 4) {
      return option?.BHKUnit;
    } else if (flag === 5) {
      return option?.UOMName;
    } else if (flag === 6) {
      return option?.FurnishType;
    } else if (flag === 7) {
      return option?.name;
    } else if (flag === 8) {
      return option?.ConstructionStatus;
    } else if (flag === 9) {
      return option?.name;
    } else if (flag === 10) {
      return option?.name;
    } else if (flag === 11) {
      return option?.name;
    } else if (flag === 12) {
      return option?.name;
    } else if (flag === 13) {
      return option?.name;
    } else if (flag === 14) {
      return option?.name;
    } else {
      return option?.PropertyType;
    }
  };

  const IsSelected = (option) => {
    if (flag === 1) {
      return selectedoption?.PropertyTypeID === option?.PropertyTypeID;
    } else if (flag === 2) {
      return selectedoption?.VerticalID === option.VerticalID;
    } else if (flag === 3) {
      return selectedoption?.ChoosePropertyID === option?.ChoosePropertyID;
    } else if (flag === 4) {
      return selectedoption?.BHKID === option?.BHKID;
    } else if (flag === 5) {
      return selectedoption?.UOMID === option?.UOMID;
    } else if (flag === 6) {
      return selectedoption?.FurnishID === option?.FurnishID;
    } else if (flag === 7) {
      return selectedoption?.id === option?.id;
    } else if (flag === 8) {
      return selectedoption?.ConstructionStatus === option?.ConstructionStatus;
    } else if (flag === 9) {
      return selectedoption?.id === option?.id;
    } else if (flag === 10) {
      return selectedoption?.id === option?.id;
    } else if (flag === 11) {
      return selectedoption?.id === option?.id;
    } else if (flag === 12) {
      return selectedoption?.id === option?.id;
    } else if (flag === 13) {
      return selectedoption?.id === option?.id;
    } else if (flag === 14) {
      return selectedoption?.id === option?.id;
    } else {
      return selectedoption?.PropertyTypeID === option?.PropertyTypeID;
    }
  };

  return (
    <div className="btn-group">
      {options?.map((opt, i) => (
        <button
          key={i}
          className={`option ${IsSelected(opt) ? "selected" : ""}`}
          onClick={() => setselectedoption(opt)}
        >
          {getOptionLabel(opt)}
        </button>
      ))}
    </div>
  );
}

export default PostProperty;
